import React, {Component} from "react";
import PageTitle from "../Components/Theme/PageTitle";
import DashboardLayout from "../Components/Theme/DashboardLayout";


export default class ToursOffered extends Component {

    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'View / Accept Tours Offered'}
                           subTitle={''}/>

            </DashboardLayout>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Pages/ToursOfferedPage.js